import './cart-sidebar.scss';
export default (() => {
  document.querySelectorAll('.cart-trigger, .cart-close, .overlay-cart').forEach(function (element) {
    element.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector('.cart-sidebar').classList.toggle('opened');
      document.querySelector('.overlay-cart').classList.toggle('opened');
      document.body.classList.toggle('side-cart-open');
    });
  });
  document.body.addEventListener('click', function (e) {
    if (e.target.closest('.cart-sidebar.opened .cart-mobile-close')) {
      document.querySelector('.cart-sidebar').classList.toggle('opened');
      document.querySelector('.overlay-cart').classList.toggle('opened');
      document.body.classList.toggle('side-cart-open');
    }
  });

  // Make sure jQuery is defined before executing jQuery code
  if ('undefined' !== typeof window.jQuery) {
    $(document.body).on('added_to_cart', function () {
      // Check if the sidebar is already open, only toggle if not open
      if (!document.querySelector('.cart-sidebar').classList.contains('opened')) {
        document.querySelector('.cart-sidebar').classList.toggle('opened');
      }
      // Check if the overlay is already open, only toggle if not open
      if (!document.querySelector('.overlay-cart').classList.contains('opened')) {
        document.querySelector('.overlay-cart').classList.toggle('opened');
      }
      // Check if the body already has the 'side-cart-open' class
      if (!document.body.classList.contains('side-cart-open')) {
        document.body.classList.toggle('side-cart-open');
      }
      jQuery(document.body).trigger("update_checkout");
    });
  }
});